/*
 * @Description: 公共相关Api
 * @Author: PF
 * @Date: 2022-09-23 16:15:12
 * @LastEditors: PF
 * @FilePath: \VUE3\src\api\publicApi.js
 */

import request from './request'

/**
 * 字典，通过类型查询
 * @param {menuId:菜单ID,lx:"授课方式"} query
 * @returns
 */
export function findZiDianLX (query) {
  return request({
    url: '/api/v2/sys/zidian/pagelist',
    method: 'POST',
    params: query
  })
}
/**
 * 字典，一级菜单
 * @param {menuId:菜单ID,lx:"授课方式"} query
 * @returns
 */
export function findZiDianTreeLX (data) {
  return request({
    url: '/api/v2/sys/zidian/tree',
    method: 'POST',
    data
  })
}
/**
 * 字典，分页
 * @param {*} query
 * @returns
 */
export function findPageDict (query) {
  return request({
    url: '/api/v2/sys/zidian/pagelist',
    method: 'POST',
    params: query
  })
}
/**
 * 查询学制
 * @returns
 */
export function findXueZhi (query) {
  return request({
    url: '/api/v2/sys/zidian/xuezhi',
    method: 'POST',
    params: query
  })
}
/**
 * 查询教学学期
 * @returns
 */
export function findJiaoXueXueQi (query) {
  return request({
    url: '/api/v2/sys/zidian/jiaoxuexueqi',
    method: 'POST',
    params: query
  })
}
/**
 * 校内机构（单位）
 * @param {*} query
 * @returns
 */
export function findXiaoNeiJiGou (data) {
  return request({
    url: '/api/v2/xiaoneijigou/list',
    method: 'POST',
    data
  })
}
/**
 * 查询校区数据 Api
 * @param {menuId:菜单ID} query
 * @returns
 */
export function findXiaoqu (data) {
  return request({
    url: '/api/v2/pdp/xiaoqu/list',
    method: 'POST',
    data
  })
}

/**
 * 获取学期列表
 * @param {*} data
 * @returns
 */
export function getTermList (data) {
  return request({
    url: '/api/v2/pdp/xueqi/pagelist',
    method: 'POST',
    data
  })
}

export function getXueQiList (data) {
  return request({
    url: '/api/v2/pdp/xueqi/list',
    method: 'POST',
    data
  })
}

/**
 * 学期
 * @param {menuId:菜单ID} query
 * @returns
 */
export function getxueqiList (data) {
  return request({
    url: '/api/v2/pdp/xueqi/pagelist',
    method: 'POST',
    data
  })
}
/**
 * 获取教职工列表
 * @param {menuId:菜单ID,} query
 * @returns
 */
export function getTeacherList (data) {
  return request({
    url: '/api/v2/pdp/jiaozhigong/list',
    method: 'POST',
    data
  })
}
/**
 * 专业列表
 * @param {menuId:菜单ID} query
 * @returns
 */
export function getzhuanyeList (data) {
  return request({
    url: '/api/v2/pdp/zhuanye/list',
    method: 'POST',
    data
  })
}
/**
 * 人才培养方案列表
 * @param {menuId:菜单ID} query // 专业ID
 * @returns
 */
export function getrencaipeiyangfanganList (data) {
  return request({
    url: '/api/v2/jiaowu/rencaipeiyangfangan/list',
    method: 'POST',
    data
  })
}
/**
 * 年级
 * @param {menuId:菜单ID} query
 * @returns
 */
export function getnianjiList (data) {
  return request({
    url: '/api/v2/pdp/nianji/list',
    method: 'POST',
    data
  })
}

/**
 * 实施教学计划
 * @param {menuId:菜单ID} query
 * @returns
 */
export function getSSJXJHList (data) {
  return request({
    url: '/api/v2/jiaowu/jiaowujiaoxuejihua/list',
    method: 'POST',
    data
  })
}
/**
 * 实施教学计划
 * @param {menuId:菜单ID} query
 * @returns
 */
export function getSSJXJHxueqiList (query) {
  return request({
    url: '/api/v2/jiaowu/jiaowujiaoxuejihua/xueqi',
    method: 'POST',
    params: query
  })
}

// 省市县
export function getAddress (query) {
  return request({
    url: '/api/v2/sys/xingzhengquhua/list',
    method: 'POST',
    params: query
  })
}
// 班级列表
export function getbanjiList (data) {
  return request({
    url: '/api/v2/pdp/banji/list',
    method: 'POST',
    data
  })
}
// 班级列表
export function banjilistXZ (query) {
  return request({
    url: '/api/v2/pdp/banji/listXZ',
    method: 'POST',
    params: query
  })
}
// 上传
export function uploadV2 (data) {
  return request({
    url: '/api/v2/sys/wenjian/upload',
    method: 'POST',
    data
  })
}
// 机构
export function getxiaoneijigouTreeList (query) {
  return request({
    url: '/api/v2/xiaoneijigou/tree',
    method: 'POST',
    params: query
  })
}
// 教室
export function getjiaoxuechangdiList (data) {
  return request({
    url: '/api/v2/zichan/jiaoxuechangdi/list',
    method: 'POST',
    data
  })
}
// 查询教室分页数据 Api
export function jiaoXueChangDiPage (query) {
  return request({
    url: '/api/v2/zichan/jiaoxuechangdi/pagelist',
    method: 'POST',
    params: query
  })
}

/**
 * 专业列表
 * @param {
 *  * menuId:菜单ID
 *    getPageNo: 页码(不传或为空时，查询全部数据)
 *    getPageSize: 分页行数(默认值:10,max<=500)
 * } query
 * @returns
 */
export function getZhuanyeList (data) {
  return request({
    url: '/api/v2/pdp/zhuanye/list',
    method: 'POST',
    data
  })
}

/**
 * 新生信息
 * @param {*} query
 * @returns
 */
export function getXueShengInfo (query) {
  return request({
    url: '/api/v2/zhaosheng/zhaoshengxinshengluqu/' + query,
    method: 'POST'
  })
}

/**
 * 学生信息
 * @param {*} query
 * @returns
 */
export function getXueSheng (query) {
  return request({
    url: '/api/v2/pdp/xuesheng/list',
    method: 'POST',
    params: query
  })
}
/**
 * 学生学期信息
 * @param {*} query
 * @returns
 */
export function getXueShengXueQi (query) {
  return request({
    url: '/api/v2/pdp/xuesheng/listxueqi',
    method: 'POST',
    params: query
  })
}
